import { Box } from '@mui/material';
import SupportForm from './components/SupportForm';
import VersionInfo from '@/components/VersionInfo/VersionInfo';

const Support = () => {
  return (
    <Box
      px="32px"
      py="24px"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Box sx={{ maxWidth: '620px', width: '100%' }}>
        <SupportForm />
        <Box sx={{ mt: 4 }}>
          <VersionInfo />
        </Box>
      </Box>
    </Box>
  );
};

export default Support;
